/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["ui-grid.credential-stores-grid .ui-grid-header-row .ui-grid-header-cell:nth-of-type(3) .ui-grid-header-title,ui-grid.credential-stores-grid .ui-grid-header-row .ui-grid-header-cell:nth-of-type(4) .ui-grid-header-title{justify-content:center}ui-grid.credential-stores-grid .ui-grid-row .ui-grid-cell:nth-of-type(3),ui-grid.credential-stores-grid .ui-grid-row .ui-grid-cell:nth-of-type(4){display:flex;justify-content:center}"];
export { styles as styles };
